/* eslint-disable @typescript-eslint/only-throw-error -- redirect é o contrato do TanStack Router */
import { createFileRoute, redirect } from '@tanstack/react-router';

import { WALLET_DASHBOARD_PATH } from '@/modules/wallet-dashboard/route';

// `/gestao-carteira` abre o Dashboard da carteira (router.tsx:1349: `<Navigate replace to='/gestao-carteira/dashboard' />`).
export const Route = createFileRoute('/_app/gestao-carteira/')({
  beforeLoad: () => {
    throw redirect({ to: WALLET_DASHBOARD_PATH, replace: true });
  },
});
